
import { SaleConfig } from "@/models/dossier-configs/sale-config";
import { SaleConfig as UserSaleConfig } from "@/models/user-configs/sale-config";
import AppSelectSaleEmailTemplate from "@/components/SelectSaleEmailTemplate.vue";
import AppSelectMailSettings from "@/components/mail/SelectMailSettings.vue";
import Vue from "vue";
import {isStringEmail} from "@/utils/strings";
import {MailSettings} from "@/models/mail-settings";
import {TranslateResult} from "vue-i18n";
import {MailSettingsService} from "@/services/mail-settings-service";
import AppSaleTypeEditGeneralPrintAfterSend from "@/components/settings-sales/SaleTypeEditGeneralPrintAfterSend.vue";


export default Vue.extend({
	data(){
		return {
			isExtraBCCAddressFocused: false,
			defaultMailSettings: null as null | MailSettings,
		};
	},
	props: {
		config: {
			type: Object as ()=>SaleConfig,
			required: true
		},
		userConfig: {
			type: Object as ()=>UserSaleConfig,
			required: true
		}
	},
	computed: {
		showExtraBCCAddressValidError():boolean {
			if (this.isExtraBCCAddressValid) {
				return false;
			}
			if (this.isExtraBCCAddressFocused) {
				return false;
			}
			return true;
		},
		isExtraBCCAddressValid():boolean {
			if (this.config.ExtraBCCAddress == "") {
				return true;
			}
			if (isStringEmail(this.config.ExtraBCCAddress)){
				return true;
			}
			return false;
		},
		isValid():boolean {
			return this.isExtraBCCAddressValid;
		},
		mailSettingsDefaultText():TranslateResult{
			let defaultName = "default";
			if (this.defaultMailSettings) {
				defaultName = this.defaultMailSettings.Label;
			}
			return this.$ct("use-default-mail-settings", {defaultName});
		},
	},
	watch: {
		isValid: {
			immediate: true,
			handler(){
				this.$emit("valid", this.isValid);
			}
		},
	},
	async mounted(){
		this.defaultMailSettings = await MailSettingsService.getDefaultSettings();
	},
	components: {
		AppSelectSaleEmailTemplate,
		AppSelectMailSettings,
		AppSaleTypeEditGeneralPrintAfterSend,
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	},
});
